module.exports = __webpack_public_path__ + "img/132.e58d50e8.jpg";